module.exports = __webpack_public_path__ + "static/media/logoListaAImprimibles.dbeff1f4.svg";